import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

interface ProtectedRouteProps {
	children: ReactNode;
	redirectTo?: string;
}

const ProtectedRoute = ({ children, redirectTo = "/" }: ProtectedRouteProps) => {
	const { isAuthenticated } = useAuth();
	
	if (!isAuthenticated) {
		return <Navigate to={redirectTo} replace />;
	}
	
	return <>{children}</>;
};

export default ProtectedRoute;